import { initMiroContent } from "../../../modules/miro/miro-ui";

export function initHome(container) {
  // console.log("initHome - initMiro Content", container);

  // Initialize the miro ui
  const cleanupMiroContent = initMiroContent(container);

  // Return the cleanup function
  return () => {
    if (cleanupMiroContent) {
      cleanupMiroContent();
    }
    // console.log("cleanupMiroContent complete");
  };
}